import { memo } from 'react';
import { ItemVM } from 'shell/view-models/item';
import { InputLabel, MenuItem } from '@mui/material';
import { PmiFormControl } from '../pmi-select/pmi-form-control';
import { PmiSelect } from '../pmi-select';

export const listReleaseMode: Array<ItemVM> = [
  {
    id: 'D',
    value: 'Duplicato',
  },
  {
    id: 'N',
    value: 'Rilascio',
  },
  {
    id: 'R',
    value: 'Rinnovo',
  },
  {
    id: 'S',
    value: 'Sostituzione',
  },
];

interface ReleaseReasonIndentityCardProps {
  disabled?: boolean;
  value: string;
  required?: boolean;
  onChange: (type?: string) => void;
  error?: boolean;
  label?: string;
  id?: string;
}

const ReleaseReasonIndentityCardComponent = ({
  disabled,
  onChange,
  value,
  error,
  required,
  label = 'Motivo rilascio',
  id = 'release-reason-identity-card',
}: ReleaseReasonIndentityCardProps): React.ReactElement => {
  const idTag = `${id}-${label}`;

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={idTag}>
        {required ? `${label} *` : label}
      </InputLabel>
      <PmiSelect
        labelId={idTag}
        id={id}
        name={id}
        value={value}
        label={required ? `${label} *` : label}
        onChange={(event) => {
          const selectedValue = event.target.value;
          onChange(selectedValue);
        }}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {listReleaseMode.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ReleaseReasonIndentityCardComponent.displayName = 'Release Reason Indentity Card list component';

const ReleaseReasonIndentityCard = memo(ReleaseReasonIndentityCardComponent);

export default ReleaseReasonIndentityCard as typeof ReleaseReasonIndentityCardComponent;
